import { chakra } from '@chakra-ui/react'

export const Wrapper = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        position: 'relative',

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            flex: 1,
        },
    }),
})

export const TextField = chakra('input', {
    baseStyle: ({ theme }) => ({
        width: '195px',
        outline: 'none !important',
        padding: '0 16px 0 0',
        border: 0,
        color: theme.palette.search.textColor,
        fontSize: '14px',
        lineHeight: '21px',
        backgroundColor: 'transparent',

        _placeholder: {
            color: theme.palette.search.placeholderColor,
        },

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            width: '100%',
        },
    }),
})

export const Label = chakra('label', {
    baseStyle: {
        display: 'block',
        width: '1px',
        height: '1px',
        margin: '-1px',
        border: 0,
        overflow: 'hidden',
    },
})

export const ClearButton = chakra('button', {
    baseStyle: {
        position: 'absolute',
        top: '2px',
        right: 0,
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
})
